import React from "react";
import { Link } from "react-router-dom";

const PromotionalThree = () => {
  return (
    <section className='promo-three pt-120   overflow-hidden'>
      <div className='container container-lg'>
        <div className='row gy-4'>
          <div className='col-sm-6'>
            <Link
              to='/shop?category=Bags'
              className='promo-three-item bg-img rounded-16 overflow-hidden d-flex justify-content-start text-decoration-none'
              style={{
                backgroundImage: `url('assets/images/thumbs/promo-three-img-1.png')`,
              }}
            >
              <div className='text-start d-flex flex-column align-items-start'>
                <h2 className='text-black fw-medium mt-30 max-w-350 text-start'>
                  YARN BAGS
                </h2>
                <span
                  className='btn btn-black d-inline-flex align-items-center rounded-pill gap-8 mt-14'
                >
                  Shop Now
                </span>
              </div>
            </Link>
          </div>
          <div className='col-sm-6'>
            <Link
              to='/workshops'
              className='promo-three-item bg-img rounded-16 overflow-hidden d-flex justify-content-end text-decoration-none'
              data-background-image='assets/images/thumbs/promo-three-img-2.png'
              style={{
                backgroundImage: `url('assets/images/thumbs/promo-three-img-2.png')`,
              }}
            >
              <div className='text-end d-flex flex-column align-items-end'>
                <h2 className='text-black fw-medium mt-30 max-w-375 text-start'>
                  WORKSHOP
                </h2>
                <span
                  className='btn btn-black d-inline-flex align-items-center rounded-pill gap-8 mt-24'
                >
                  Join Now
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalThree;